module.exports = __webpack_public_path__ + "img/coins.542547a1.png";